import script from "./CommunityActivityTabs.vue?vue&type=script&setup=true&lang=js"
export * from "./CommunityActivityTabs.vue?vue&type=script&setup=true&lang=js"

import "./CommunityActivityTabs.vue?vue&type=style&index=0&id=2cef6bd8&lang=scss"

const __exports__ = script;

export default __exports__